/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Info_DescInputs */

const es_toast_info_desc = /** @type {(inputs: Toast_Info_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se realizaron cambios`)
};

const en_toast_info_desc = /** @type {(inputs: Toast_Info_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes were made`)
};

/**
* | output |
* | --- |
* | "No changes were made" |
*
* @param {Toast_Info_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_info_desc = /** @type {((inputs?: Toast_Info_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Info_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_info_desc(inputs)
	return en_toast_info_desc(inputs)
});
export { toast_info_desc as "toast.info_desc" }